<template>
  <div class="text-filter">
    <el-select class="form-li-item" v-model="formData.rule" @change="changeRuleHandle">
      <el-option-group v-for="group in rules" :key="group.label" :label="group.label">
        <el-option
          v-for="ruleItem in group.options"
          :key="ruleItem.value"
          :value="ruleItem.value"
          :label="ruleItem.label"
        />
      </el-option-group>
    </el-select>

    <template v-if="isDuplicateCount">
      <el-select class="form-li-item" v-model="formData.symbol" placeholder="请选择">
        <el-option value=">" label="大于" />
        <el-option value="<" label="小于" />
        <el-option value=">=" label="大于等于" />
        <el-option value="<=" label="小于等于" />
        <el-option value="=" label="等于" />
      </el-select>

      <el-input-number
        v-model="formData.num"
        class="form-li-item"
        placeholder="请输入数值"
        :min="0"
        :max="10000000"
        :precision="0"
        :controls="false"
      />
    </template>

    <el-select
      v-show="!isDuplicateCount && isRemoteKeyword"
      class="form-li-item search-item"
      v-model="formData.keywordArr"
      filterable
      multiple
      remote
      placeholder="输入关键词搜索"
      :remote-method="remoteKeywordHandle"
      :loading="keywordRemoteLoading"
    >
      <el-option
        v-for="item in keywordList"
        :key="item.label"
        :label="`${item.label}${item.total ? `(${item.total})` : ''}`"
        :value="item.label"
      />
    </el-select>

    <el-input
      v-show="!isDuplicateCount && !isRemoteKeyword && !isExistsRule"
      class="form-li-item search-item"
      :maxlength="50"
      v-model="formData.keyword"
      placeholder="用内容值搜索"
    />
  </div>
</template>

<script>
import { debounce, cloneDeep } from 'lodash';
import { services } from '@/service';

export default {
  props: {
    currentColumn: {
      type: Object,
      required: true
    },
    courseId: {
      type: String,
      default: ''
    },
    defaultFormData: {
      type: Object,
      default: () => null
    },
    uniqueId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formData: null,
      keywordList: [],
      keywordRemoteLoading: false,
      lastSearchWord: ''
    };
  },
  inject: ['getQueryBody'],
  computed: {
    defaultDataStatic() {
      const info = {
        rule: this.rules[0].options[0].value,
        keyword: '',
        keywordMode: 'input',
        keywordArr: [],
        num: undefined,
        symbol: '>'
      };

      if (this.isDict) {
        info.rule = 'remote';
        info.keywordMode = 'remote';
      }

      return info;
    },
    isDict() {
      return this.currentColumn.deputy_type === 'dict';
    },
    isRemoteKeyword() {
      return this.formData.keywordMode === 'remote';
    },
    rules() {
      const normalRules = [
        { value: 'DUPLICATE_COUNT', label: '重复项计数' },
        { value: 'MONODROME', label: '单值' },
        { value: 'MULTIVALUED', label: '多值' },
        { value: 'term', label: '等于' },
        { value: 'term_not', label: '不等于' },
        { value: 'include', label: '包含' },
        { value: 'exclude', label: '不包含' },
        { value: 'exists_not', label: '文本为空' },
        { value: 'exists', label: '文本不为空' }
      ];
      if (this.isDict) {
        normalRules.unshift({ value: 'remote', label: '关键词筛选' });
      }

      return [
        {
          label: '文本筛选',
          options: normalRules
        }
      ];
    },
    isExistsRule() {
      return ['exists', 'exists_not', 'MONODROME', 'MULTIVALUED'].includes(this.formData.rule || '');
    },
    isDuplicateCount() {
      return this.formData.rule === 'DUPLICATE_COUNT';
    }
  },
  created() {
    this.formData = cloneDeep(this.defaultDataStatic);
    if (this.defaultFormData) {
      this.formData = { ...this.formData, ...this.defaultFormData };
    }
    if (this.formData.keywordMode === 'remote') {
      this.formData.rule = 'remote';
    }
    if (this.isDict) {
      this.remoteKeywordHandle();
      this.remoteKeywordHandle = debounce(this.remoteKeywordHandle.bind(this), 500);
    }
    this.$watch(
      'formData',
      () => {
        this.$emit('change');
      },
      { deep: true }
    );
  },
  methods: {
    changeRuleHandle(val) {
      this.formData.keywordMode = val === 'remote' ? 'remote' : 'input';
    },
    validateInfo() {
      const newFormData = { ...this.formData };
      if (this.isDuplicateCount) {
        if (!this.formData.num && this.formData.num !== 0) {
          throw new Error('请输入重复计数值');
        }
      } else if (this.isRemoteKeyword) {
        if (this.formData.keywordArr.length < 1 && !this.isExistsRule) {
          if (this.keywordList.length < 1) {
            throw new Error('该字段标签暂无关键词，请前往标注添加关键词');
          } else {
            throw new Error('请选择关键字');
          }
        }
      } else if (!this.isExistsRule && !this.formData.keyword) {
        throw new Error('请输入文本值');
      }

      if (this.isRemoteKeyword) {
        return { ...newFormData, rule: 'term', keyword: '' };
      } else {
        return { ...newFormData, keywordArr: [] };
      }
    },
    allCheckHandle(val) {
      if (val) {
        const currentKeywordArr = [...this.formData.keywordArr];
        this.keywordList.forEach(item => currentKeywordArr.push(item.label));
        this.formData.keywordArr = [...new Set(currentKeywordArr)];
      } else {
        const currentKeywordObj = {};
        this.formData.keywordArr.forEach(keyword => {
          currentKeywordObj[keyword] = true;
        });
        this.keywordList.forEach(item => {
          if (currentKeywordObj[item.label]) {
            currentKeywordObj[item.label] = false;
          }
        });
        this.formData.keywordArr = Object.keys(currentKeywordObj).filter(keyword => currentKeywordObj[keyword]);
      }
    },
    refreshHandle() {
      if (this.isDict) {
        this.remoteKeywordHandle(this.lastSearchWord);
      }
    },
    async remoteKeywordHandle(word = '') {
      try {
        this.keywordRemoteLoading = true;
        let filterBody = {};
        if (this.getQueryBody) {
          filterBody = this.getQueryBody(this.uniqueId);
        }
        this.lastSearchWord = word;
        const { data } = await services.caseRule.getKeywordByField({
          ...filterBody,
          courseware_id: this.courseId,
          labelId: this.currentColumn.field_name,
          keyword: word
        });
        this.keywordList = data;
      } catch (err) {
        this.$error(err);
      } finally {
        this.keywordRemoteLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-filter {
  height: 100%;
  display: flex;
  align-items: flex-start;

  .form-li-item {
    width: 160px;
    margin-left: 5px;
    &.search-item {
      width: 344px;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
